// extracted by mini-css-extract-plugin
export default {"bowl":"QFOJvv","title":"wrHbUW","textContainer":"DVaBYa","withMaxWidth":"eekPoe","subtitle":"OKXYA1","subtitleMobile":"XY0MQd","buttonContainer":"SuMtCW","buttonBackground":"WHZ5TG"};